import { motion } from "framer-motion";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import Confetti from "react-confetti";
import { useNavigate } from "react-router-dom";
import useSongStore from "../store/song.store";
import useAuthStore from "../store/auth.store";
import useLayoutStore from "../store/layout.store";

type IProps = {
  title: string;
  amount: number;
  prizeText: string;
};

const WinnerScreen: FC<IProps> = ({ title, prizeText }) => {
  const navigate = useNavigate();

  const setUsername = useAuthStore((state) => state.setUsername);
  const setToneCode = useSongStore((state) => state.setToneCode);
  const setSongDetails = useSongStore((state) => state.setSongDetails);
  const setShowLogoInHeader = useLayoutStore((state) => state.setShowLogoInHeader);

  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // برای تنظیم سایز confetti
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const resetWheel = () => {
    setToneCode(null);
    setSongDetails(null);
    setUsername(null);
    setShowLogoInHeader(true);
    Cookies.remove("mci_elecamp_token");
    navigate("/");
  };

  return (
    <div
      className="relative w-full h-screen flex flex-col justify-center items-center text-center text-white"
      style={{
        background: "rgba(148, 221, 255, 0.85)",
      }}
    >
      {title === "پوچ" ? (
        <>
          <motion.img
            alt="null-result"
            src="/images/null-result.svg"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, damping: 12 }}
            className="-mt-28 size-[90%] md:size-[50%]"
          />

          {/* <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="text-2xl font-bold mt-10 px-10"
          >
            {prizeText}
          </motion.p> */}
        </>
      ) : (
        <>
          <Confetti
            width={windowSize.width}
            height={windowSize.height}
            numberOfPieces={400}
            gravity={0.3}
            recycle={false}
          />

          <motion.h1
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, damping: 12 }}
            className="text-4xl font-extrabold text-orange-500 mb-8 -mt-32"
          >
            تبریک 🎉
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="text-2xl font-bold mb-4 px-10 text-black"
          >
            {prizeText}
          </motion.p>
        </>
      )}

      <motion.button
        onClick={resetWheel}
        className="bg-[#f54f02] text-white px-8 py-3 rounded-xl text-lg font-semibold shadow-lg hover:bg-orange-600 transition absolute bottom-[26%]"
      >
        شروع دوباره
      </motion.button>

      <div className="absolute bottom-20 left-1/2 -translate-x-1/2">
        <img src="/images/logo2.svg" alt="elecamp" className="w-56" />
      </div>
    </div>
  );
};

export default WinnerScreen;
